import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";

const FormDatePicker = ({
  value,
  onChange,
  label,
  isValid = true,
  errorMessage,
  tick = false,
  disabled = false,
  labelClassName,
  maxDate, // optional custom max date
  restrictAge18 = false, // restrict 18+ years
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const showFloatingLabel = isFocused || value;
  const datePickerRef = useRef(null);

  // Calculate max date
  const today = new Date();
  let finalMaxDate = maxDate || today;
  if (restrictAge18) {
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    finalMaxDate = eighteenYearsAgo;
  }

  const handleCalendarClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  return (
    <>
      <style>
        {`
          .form-input-wrapper {
            position: relative;
            margin-bottom: 1rem;
            width: 340px;
            margin-left: auto;
            margin-right: auto;
          }

          .form-input-field {
            width: 100%;
            height: 55px;
            border-radius: 5px;
            padding: 20px 40px 8px 12px;
            font-size: 16px;
            outline: none;
          }

          @media (max-width: 340px) {
            .form-input-wrapper {
              width: 300px;
            }
            .form-input-field {
              width: 300px;
            }
          }

          @media (max-width: 320px) {
            .form-input-wrapper {
              width: 310px;
            }
            .form-input-field {
              width: 310px;
            }
          }

          /* ✅ Ensure DatePicker popup is always visible */
          .react-datepicker-popper {
            z-index: 999999 !important;
          }

          .react-datepicker-wrapper {
            width: 100%;
          }

          .react-datepicker__input-container input {
            width: 100%;
            border: none;
            outline: none;
            background: transparent;
            font-size: 16px;
          }

          .calendar-icon {
            position: absolute;
            right: 40px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            color: #999;
          }

          .tick-icon {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            height: 20px;
            width: 20px;
          }
        `}
      </style>

      <div className="form-input-wrapper border-[1px] rounded-md border-gray-400 bg-white">
        <DatePicker
          ref={datePickerRef}
          selected={value ? new Date(value) : null}
          onChange={(date) => onChange({ target: { value: date } })}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholderText="DD/MM/YYYY"
          dateFormat="dd/MM/yyyy"
          maxDate={finalMaxDate}
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={100}
          popperPlacement="bottom-start"
          className="form-input-field font-atkinson"
          disabled={disabled}
          {...props}
        />

        {/* Floating label */}
        <label
          htmlFor={label}
          className={labelClassName}
          style={{
            position: "absolute",
            width:"60%",
            left: "12px",
            top: showFloatingLabel ? "6px" : "18px",
            fontSize: showFloatingLabel ? "11px" : "14px",
            color: isValid ? "#B3B3B3" : "red",
            backgroundColor: disabled ? "#F5F5F5" : "white",
            transition: "all 0.2s ease-in-out",
            pointerEvents: "none",
          }}
        >
          {label || "Label"}
        </label>

        {/* Calendar Icon */}
        {!disabled && (
          <Calendar
            className="calendar-icon"
            size={20}
            onClick={handleCalendarClick}
          />
        )}

        {/* Tick icon */}
        {tick && isValid && !disabled && (
          <img
            src="/assets/img/lightGreenTick.svg"
            alt="tick"
            className="tick-icon"
          />
        )}

        {/* Error message */}
        {!isValid && !disabled && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "6px" }}>
            {errorMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default FormDatePicker;
